module.exports = __webpack_public_path__ + "media/application/images/ui/wmd-buttons-671a89aae20aebf5ba7a573197027c04.png";